const _import = name => {
  return resolve => require([`../../views/${name}`], resolve)
}

const matchChild = [
  {
    path: '/match/',
    component: _import('match'),
    children: [
      {
        path: '/',
        redirect: '-2'
      },
      {
        path: ':id',
        name: 'Match',
        meta: { navShow: true, titleHide: false, title: '赛事' },
        component: _import('match/list'),
      },
      {
        meta: { navShow: false, titleHide: true, title: '赛事详情' },
        path: 'details/:id',
        name: 'MatchDetails',
        component: _import('match/details'),
      },
    ]
  },
  {
    meta: { navShow: false, titleHide: true, requireAuth:true, title: '赛事投注记录' },
    path: '/match-record',
    name: 'MatchRecord',
    component: _import('match/record'),
  }
]

export default matchChild



// WEBPACK FOOTER //
// ./src/pages/build902/router/module/Match.js